import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class ApiTokenStore extends LocalModel {
    constructor() {
        super('apiToken', {
            namePlural: 'apiTokens',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/apitokens/',
                    params: {
                        limit: 100,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/apitokens/',
                    params: {},
                },
                save: {
                    url: '/api/apitokens/',
                    params: {},
                },
                delete: {
                    url: '/api/apitokens/',
                    params: {},
                },
            },
        });
    }

    @observable newApiToken = {};

    @observable apiToken = {};

    @observable apiTokens = [];

    @observable lastCreatedToken = null;

    @observable validPermissions = [
        'calendarEvent:read',
        'calendarEvent:write',
        'visitor:read',
        'visitor:write',
        'sale:read',
        'sale:write',
        'salePayment:read',
        'salePayment:write',
        'product:read',
        'product:write',
        'timeTracker:read',
        'timeTracker:write',
        'megalinkIngest:write',
    ];

    @action
    clearAll() {
        this.newApiToken = {};
        this.apiToken = {};
        this.apiTokens = [];
        this.lastCreatedToken = null;
    }

    @action
    clearLastCreatedToken() {
        this.lastCreatedToken = null;
    }

    async createToken({ name, description, permissions, dataFilters, allowedFields, expiresAt }) {
        const response = await util.fetchApi('/api/apitokens/', {
            method: 'POST',
        }, {
            name,
            description,
            permissions,
            dataFilters,
            allowedFields,
            expiresAt,
        });

        if (response.status === 201) {
            // Store the created token with raw token value (only shown once!)
            this.updateKeyValue('lastCreatedToken', response.data);
            // Reload the token list (without raw token)
            await this.load();
        }

        return response;
    }

    async revokeToken(tokenId) {
        const response = await util.fetchApi(`/api/apitokens/${tokenId}`, {
            method: 'PATCH',
        }, {
            id: tokenId,
            isActive: false,
        });

        if (response.status === 202) {
            // Reload the token list
            await this.load();
        }

        return response;
    }

    async deleteToken(tokenId) {
        const response = await util.fetchApi(`/api/apitokens/${tokenId}`, {
            method: 'DELETE',
        }, {
            id: tokenId,
        });

        if (response.status === 200) {
            // Reload the token list
            await this.load();
        }

        return response;
    }

    async updateToken(tokenId, { name, description, permissions, dataFilters, allowedFields, expiresAt }) {
        const updateData = { id: tokenId };

        if (name !== undefined) updateData.name = name;
        if (description !== undefined) updateData.description = description;
        if (permissions !== undefined) updateData.permissions = permissions;
        if (dataFilters !== undefined) updateData.dataFilters = dataFilters;
        if (allowedFields !== undefined) updateData.allowedFields = allowedFields;
        if (expiresAt !== undefined) updateData.expiresAt = expiresAt;

        const response = await util.fetchApi(`/api/apitokens/${tokenId}`, {
            method: 'PATCH',
        }, updateData);

        if (response.status === 202) {
            // Reload the token list
            await this.load();
        }

        return response;
    }
}

const store = new ApiTokenStore();
export default store;
